import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Message, SelectItem } from 'primeng/primeng';
import { MANUTENCAO_COMUNICADO } from '../../../app.constants';
import { TipoComunicadosEnum } from '../../shared/dominios/enum/tipo-comunicados.enum';
import { ProcorConsultaModel } from '../../shared/models/procor-consulta.model';
import { StorafeUtil } from '../../shared/util/storasge.util';
import { AdministrativoService } from '../service/administrativo.service';
import { ProcorManutencaoComunicadoService } from './service/procor-manutencao-comunicado.service';

@Component({
  selector: 'app-procor-manutencao-comunicado',
  templateUrl: './procor-manutencao-comunicado.component.html',
  styleUrls: ['./procor-manutencao-comunicado.component.css']
})
export class ProcorManutencaoComunicadoComponent implements OnInit {

  param: string;

  procorConsultaModel = new ProcorConsultaModel(null, null, null);


  tiposComunicadosLista: SelectItem[] = TipoComunicadosEnum.values;
  msgs: Message[] = [];

  constructor(
    private toastrService: ToastrService,
    private procorManutencaoComunicadoService: ProcorManutencaoComunicadoService,
    private route: Router
  ) { }

  ngOnInit() {
    this.param = '/cardMenus/cardMenuAdministrativo';
    this.msgs.push({ severity: 'info', summary: 'Atenção', detail: 'Todos os campos são de preenchimento obrigatórios!' });
  }



  getFormGroupClass(isValid: boolean, isPristine: boolean): {} {
    return {
      'form-group': true,
      'has-danger': !isValid && !isPristine,
      'has-success': isValid && !isPristine
    };
  }

  getFormControlClass(isValid: boolean, isPristine: boolean): {} {
    return {
      'form-control': true,
      'form-control-danger': !isValid && !isPristine,
      'form-control-success': isValid && !isPristine
    };
  }




  onSubmit(form) {

    this.getVerificarComun(form.value);
    this.gravaSessionStorage(MANUTENCAO_COMUNICADO, form.value);

  }


  async getVerificarComun(procorConsultaModel: ProcorConsultaModel) {
    const verificado = await this.procorManutencaoComunicadoService.getVerificarComun(procorConsultaModel.tpComunicados, procorConsultaModel.sqComunicados, procorConsultaModel.anoSq);
    this.direcionarCrudManutencaoComunicado(verificado);
  }

  gravaSessionStorage(titulo: string, procorConsultaModel: ProcorConsultaModel): void {
    StorafeUtil.gravaSessionStorage(titulo, procorConsultaModel);
  }

  direcionarCrudManutencaoComunicado(verificado: Boolean): void {
    (verificado) ?
      this.route.navigateByUrl('/administrativo/procor/alterar')
      : this.route.navigateByUrl('/administrativo/procor/incluir')
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/administrativo/procor-manutencao-comunicado/procor-manutencao-comunicado.component.ts